import PropfirmsPage from '@/modules/propfirms/propfirms-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/propfirms')({
  component: PropfirmsPage,
});
